"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./TermsAndConditions.css");
var Checkbox_1 = require("../../atoms/Checkbox");
var utils_1 = require("../../../utils/utils");
var changeData = function (isChecked) {
    /*TO-DO:update with centralized logging.*/
};
var TermsAndConditions = /** @class */ (function (_super) {
    __extends(TermsAndConditions, _super);
    function TermsAndConditions(props) {
        var _this = _super.call(this, props) || this;
        _this.initializeEvents();
        return _this;
    }
    TermsAndConditions.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.termsAndConditions },
            React.createElement("div", { className: styles.termsAndConditionsTitle }, this.props.data.title),
            React.createElement("div", { className: styles.termsAndConditionsText }, this.props.data.description),
            React.createElement("div", { className: styles.termsAndConditionsLink },
                React.createElement("a", { href: this.props.data.linkHref }, this.props.data.linkText)),
            React.createElement(Checkbox_1.default, { testId: utils_1.default(this.props.testId, 'Checkbox'), data: { value: this.props.data.isTermsApproved, text: this.props.data.consent }, events: this.checkboxEvents }),
            React.createElement("div", { className: styles.termsAndConditionsText })));
    };
    TermsAndConditions.prototype.initializeEvents = function () {
        this.checkboxEvents = {
            onCheckboxChange: this.props.events.onCheckboxChange,
        };
    };
    return TermsAndConditions;
}(React.Component));
exports.default = TermsAndConditions;
//# sourceMappingURL=TermsAndConditions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/TermsAndConditions/TermsAndConditions.js
// module id = 1337
// module chunks = 8